<template>
  <q-page class="q-pa-md" style="height: 100%; overflow-y: auto">
    <q-dialog class="rounded-borders" v-model="dialogDetalleIngresos" persistent>
      <q-card style="width: 1200px; max-width: 80vw" class="shadow-0">
        <q-card-section class="row items-center q-pb-none">
          <div class="text-h6">Detalles Ingresos</div>
          <q-space />
          <q-btn icon="close" flat round dense v-close-popup />
        </q-card-section>
        <q-card-section>
          <q-table dense title="Cuentas Por Cobrar" class="shadow-0" bordered :data="dataListIngresos"
            :loading="loadingIngresos" :columns="columnsIngresos" color="primary" row-key="_id"
            :pagination="initialPagination">
            <template v-slot:body="props">
              <q-tr :props="props">
                <q-td key="nombre" :props="props" @click="verItem(props.row)">{{
                  props.row.nombre
                }}</q-td>
                <q-td key="concepto" :props="props" @click="verItem(props.row)">{{ props.row.concepto }}</q-td>
                <q-td key="monto" :props="props" @click="verItem(props.row)">{{
                  formatoMonedaMexicana(props.row.monto)
                }}</q-td>
                <q-td key="tipo" :props="props" @click="verItem(props.row)">{{
                  props.row.tipo ? props.row.tipo.toUpperCase() : ""
                }}</q-td>
                <q-td key="fechacreacion" :props="props" @click="verItem(props.row)">{{
                  formatearFecha(props.row.fechacreacion) }}</q-td>
                <q-td key="fechamaximapago" :props="props" @click="verItem(props.row)">{{
                  formatearFecha(props.row.fechamaximapago) }}</q-td>
                <q-td key="estado" :props="props">
                  <q-badge v-if="props.row.estado == 'XC'" color="orange" label="Cuenta por Cobrar" />
                  <q-badge v-if="props.row.estado == 'V'" color="purple" label="Pendiente de Validar" />
                  <q-badge v-if="props.row.estado == 'P'" color="green" label="Pagado" />
                </q-td>
              </q-tr>
            </template>
          </q-table>
        </q-card-section>
      </q-card>
    </q-dialog>

    <q-dialog class="rounded-borders" v-model="dialogDetalleGastos" persistent>
      <q-card style="width: 1200px; max-width: 80vw" class="shadow-0">
        <q-card-section class="row items-center q-pb-none">
          <div class="text-h6">Detalles Gastos</div>
          <q-space />
          <q-btn icon="close" flat round dense v-close-popup />
        </q-card-section>
        <q-card-section>
          <q-table dense class="shadow-0" bordered :data="dataListGastos" :loading="loadingGastos"
            :columns="columnsGastos" color="primary" row-key="_id" :pagination="initialPagination">
            <template v-slot:body="props">
              <q-tr :props="props" class="hover-fila">
                <q-td key="nombre" :props="props" @click="verItem(props.row)">{{
                  props.row.nombre
                }}</q-td>
                <q-td key="concepto" :props="props" @click="verItem(props.row)">{{ props.row.concepto }}</q-td>
                <q-td key="monto" :props="props" @click="verItem(props.row)">{{
                  formatoMonedaMexicana(props.row.monto)
                }}</q-td>
                <q-td key="tipo" :props="props" @click="verItem(props.row)">{{
                  props.row.tipo ? props.row.tipo.toUpperCase() : ""
                }}</q-td>
                <q-td key="fechacreacion" :props="props" @click="verItem(props.row)">{{
                  formatearFecha(props.row.fechacreacion) }}</q-td>
                <q-td key="fechamaximapago" :props="props" @click="verItem(props.row)">{{
                  formatearFecha(props.row.fechamaximapago) }}</q-td>
                <q-td key="estado" :props="props">
                  <q-badge v-if="props.row.estado == 'XP'" color="orange" label="Cuenta por Pagar" />
                  <q-badge v-if="props.row.estado == 'V'" color="purple" label="Pendiente de Validar" />
                  <q-badge v-if="props.row.estado == 'P'" color="green" label="Pagado" />
                </q-td>
              </q-tr>
            </template>
          </q-table>
        </q-card-section>
      </q-card>
    </q-dialog>

    <q-dialog v-model="dialogPdf" maximized transition-show="slide-up" transition-hide="slide-down">
      <visor-pdf @closeDialog="CierraDialogPdf" @closeDialogTimbrado="CierraDialogPdfTimbrado"></visor-pdf>
    </q-dialog>

    <q-card class="q-pa-md q-mt-md">
      <q-card-section>
        <div class="row">
          <div class="col-12">
            <div class="text-h6 text-primary">Reporte General</div>
            <div class="text-subtitle2 text-grey">
              Aquí podrás gestionar toda la información de forma general de
              todos los movimientos.
            </div>
          </div>
          <div class="col-12 row no-wrap justify-end q-mt-md">
            <q-select dense outlined v-model="selectedAño" style="width: 28%" class="q-ma-none q-pa-none q-mr-sm"
              :options="itemsAños" label="Año" />
            <!-- </div>
                            <div class="col-3 row no-wrap justify-end q-mt-md"> -->
            <q-select dense outlined v-model="selectedMesInicial" style="width: 28%" class="q-ma-none q-pa-none q-mr-sm"
              :options="itemsMeses" option-label="mes" label="Del mes" />
            <!-- </div>
                            <div class="col-3 row no-wrap justify-end q-mt-md"> -->
            <q-select dense outlined v-model="selectedMesFinal" style="width: 28%" class="q-ma-none q-pa-none q-mr-sm"
              :options="itemsMeses" option-label="mes" label="Al mes" />
            <!-- </div> -->
            <!-- <div class="col-3 row no-wrap justify-end q-mt-md"> -->
            <q-btn color="primary" style="width: 14%" icon="mdi-magnify" label="CONSULTAR"
              @click="GetReporteGeneral()" />
          </div>
        </div>
      </q-card-section>
      <q-separator />
      <q-card-section>
        <q-list bordered>
          <q-expansion-item style="background-color: #00bbff" icon="mdi-chart-gantt" label="Ingresos vs Gastos"
            header-class="text-accent">
            <q-separator />
            <q-card>
              <q-card-section>
                <div class="row">
                  <div class="col">
                    <div class="text-h6 text-primary">Ingresos vs Gastos</div>
                    <div class="text-subtitle2 text-grey">
                      Podras ver de forma general los ingresos y gastos por mes
                    </div>
                  </div>
                  <div class="col text-right">
                    <q-btn color="green" style="width: 200px" icon="mdi-table" label="EXPORTAR EXCEL"
                      @click="exportarExcelIngresosGastos" />
                  </div>
                </div>
              </q-card-section>
              <q-separator />
              <q-table dense class="shadow-1" :data="listaIE" :loading="loadingIE" :columns="columnsIE" color="primary"
                row-key="mes" :pagination="initialPagination">
                <template v-slot:body="props">
                  <q-tr :props="props">
                    <q-td key="año" :props="props">{{ props.row.año }}</q-td>
                    <q-td key="mes" :props="props">{{ props.row.mes }}</q-td>
                    <q-td class="hover-fila-row" key="ingresos" :props="props"
                      @click="verDetallesIngresos(props.row)">{{ props.row.ingresos }}</q-td>
                    <q-td class="hover-fila-row" key="totalI" :props="props" @click="verDetallesIngresos(props.row)">{{
                      FormatCurrency(props.row.totalI) }}</q-td>
                    <q-td class="hover-fila-row" key="egresos" :props="props" @click="verDetallesGastos(props.row)">{{
                      props.row.egresos }}</q-td>
                    <q-td class="hover-fila-row" key="totalE" :props="props" @click="verDetallesGastos(props.row)">{{
                      FormatCurrency(props.row.totalE) }}</q-td>
                    <q-td key="total" :props="props">{{
                      FormatCurrency(props.row.total)
                    }}</q-td>
                  </q-tr>
                </template>
              </q-table>
              <div class="row q-col-gutter-sm">
                <div class="col-6">
                  <q-chip size="md" class="text-right" square color="primary" style="width: 100%" text-color="white">
                    <div class="row full-width">
                      Total Ingresos
                      <q-space />
                      {{ getSumaTotalIngresos }}
                    </div>
                  </q-chip>
                </div>
                <div class="col-6 q-pr-sm">
                  <q-chip size="md" class="text-right" square color="primary" style="width: 100%" text-color="white">
                    <div class="row full-width">
                      Total Egresos
                      <q-space />
                      {{ getSumaTotalEgresos }}
                    </div>
                  </q-chip>
                </div>
              </div>
            </q-card>
          </q-expansion-item>
        </q-list>
      </q-card-section>
    </q-card>

    <q-card class="q-pa-md q-mt-md">
      <q-card-section>
        <div class="row">
          <div class="col-12">
            <div class="text-h6 text-primary">Reporte por Cliente</div>
            <div class="text-subtitle2 text-grey">
              Aquí podrás gestionar toda la información de forma clara y
              eficiente de tus clientes.
            </div>
          </div>
          <div class="col-12 row no-wrap justify-end q-mt-md">
            <q-select dense outlined v-model="clienteSelect" style="width: 100%" class="q-ma-none q-pa-none q-mr-sm"
              :options="clientes" label="Cliente" option-label="texto" />
            <!-- <q-input class="q-ma-none q-pa-none q-mr-sm" dense outlined v-model="fechaI"
                            label="Fecha Inicial" mask="date" bottom-slots placeholder="yyyy/MM/dd">
                            <template v-slot:append>
                                <q-icon name="event" class="cursor-pointer q-ma-none q-pa-none">
                                    <q-popup-proxy class="q-ma-none q-pa-none" ref="qDateProxy" transition-show="scale"
                                        transition-hide="scale">
                                        <q-date class="q-ma-none q-pa-none" v-model="fechaI">
                                            <div class="q-ma-none q-pa-none row items-center justify-end">
                                                <q-btn class="q-ma-none q-pa-none" v-close-popup label="Ok"
                                                    color="primary" flat />
                                            </div>
                                        </q-date>
                                    </q-popup-proxy>
                                </q-icon>
                            </template>
</q-input>
<q-input class="q-ma-none q-pa-none q-mr-sm" dense outlined v-model="fechaF" label="Fecha Final" mask="date"
    bottom-slots placeholder="yyyy/MM/dd">
    <template v-slot:append>
                                <q-icon name="event" class="cursor-pointer q-ma-none q-pa-none">
                                    <q-popup-proxy class="q-ma-none q-pa-none" ref="qDateProxy" transition-show="scale"
                                        transition-hide="scale">
                                        <q-date class="q-ma-none q-pa-none" v-model="fechaF">
                                            <div class="q-ma-none q-pa-none row items-center justify-end">
                                                <q-btn class="q-ma-none q-pa-none" v-close-popup label="Ok"
                                                    color="primary" flat />
                                            </div>
                                        </q-date>
                                    </q-popup-proxy>
                                </q-icon>
                            </template>
</q-input> -->
            <q-btn color="primary" style="width: 250px" icon="mdi-magnify" label="CONSULTAR" @click="GetReporte()" />
          </div>
        </div>
        <div></div>
      </q-card-section>
      <q-separator />
      <q-card-section>
        <q-list bordered>
          <q-expansion-item style="background-color: #00bbff" icon="mdi-car" label="Autos" header-class="text-accent">
            <q-separator />
            <q-card>
              <q-card-section>
                <div class="row">
                  <div class="col">
                    <div class="text-h6 text-primary">Autos del Cliente</div>
                    <div class="text-subtitle2 text-grey">
                      Podras ver los detalles de sus vehiculos del Cliente
                    </div>
                  </div>
                  <div class="col text-right">
                    <q-btn color="green" style="width: 200px" icon="mdi-table" label="EXPORTAR EXCEL"
                      @click="exportarExcelAutos" />
                  </div>
                </div>
              </q-card-section>
              <q-separator />
              <q-table dense class="shadow-1" :data="listaCarros" :loading="loading" :columns="columns" color="primary"
                row-key="_id" :pagination="initialPagination">
                <template v-slot:body="props">
                  <q-tr :props="props" class="hover-fila">
                    <q-td key="marca" :props="props" @click="verItemAuto(props.row)">{{ props.row.marca }}</q-td>
                    <q-td key="modelo" :props="props" @click="verItemAuto(props.row)">{{ props.row.modelo }}</q-td>
                    <q-td key="version" :props="props" @click="verItemAuto(props.row)">{{ props.row.version }}</q-td>
                    <q-td key="tipoVehiculo" :props="props" @click="verItemAuto(props.row)">{{ props.row.tipoVehiculo
                    }}</q-td>
                    <q-td key="anio" :props="props" @click="verItemAuto(props.row)">{{ props.row.anio }}</q-td>

                    <q-td key="color" :props="props" @click="verItemAuto(props.row)">{{ props.row.color }}</q-td>

                    <q-td key="agencia" :props="props" @click="verItemAuto(props.row)">{{ props.row.agencia }}</q-td>

                    <q-td key="numeroMotor" :props="props" @click="verItemAuto(props.row)">{{ props.row.numeroMotor
                    }}</q-td>

                    <q-td key="numeroSerie" :props="props" @click="verItemAuto(props.row)">{{ props.row.numeroSerie
                    }}</q-td>

                    <q-td key="placa" :props="props" @click="verItemAuto(props.row)">{{ props.row.placa }}</q-td>

                    <q-td key="permiso" :props="props" @click="verItemAuto(props.row)">{{ props.row.permiso }}</q-td>

                    <q-td key="estadoPlaca" :props="props" @click="verItemAuto(props.row)">{{ props.row.estadoPlaca
                    }}</q-td>

                    <q-td key="fechaadquisicion" :props="props" @click="verItemAuto(props.row)">{{
                      formatearFecha(props.row.fechaadquisicion) }}</q-td>
                  </q-tr>
                </template>
              </q-table>
            </q-card>
          </q-expansion-item>

          <q-separator />

          <q-expansion-item style="background-color: #2ec7ff" icon="mdi-file-document" label="Contratos"
            header-class="text-accent">
            <q-separator />
            <q-card>
              <q-card-section>
                <div class="row">
                  <div class="col">
                    <div class="text-h6 text-primary">
                      Contratos del Cliente
                    </div>
                    <div class="text-subtitle2 text-grey">
                      Podras ver los detalles de los contratos del Cliente
                    </div>
                  </div>
                  <div class="col text-right">
                    <q-btn color="green" style="width: 200px" icon="mdi-table" label="EXPORTAR EXCEL"
                      @click="exportarExcelContratos()" />
                  </div>
                </div>
              </q-card-section>
              <q-separator />
              <q-table dense title="Contratos" class="shadow-1" :data="dataListContratos" :columns="columnsContratos"
                color="primary" row-key="_id" :pagination="initialPaginationContratos">
                <template v-slot:body="props">
                  <q-tr :props="props" class="hover-fila">
                    <q-td key="nregistro" :props="props" @click="verItemContratos(props.row)">{{ props.row.nregistro
                    }}</q-td>
                    <q-td key="nombre" :props="props" @click="verItemContratos(props.row)">{{ props.row.nombre }}</q-td>
                    <q-td key="plazos" :props="props" @click="verItemContratos(props.row)">{{ props.row.plazos }}</q-td>
                    <q-td key="vehiculo" :props="props" @click="verItemContratos(props.row)">
                      {{
                        props.row.marca +
                        " " +
                        props.row.modelo +
                        " " +
                        props.row.color
                      }}
                    </q-td>
                    <q-td key="nserie" :props="props" @click="verItemContratos(props.row)">{{ props.row.nserie }}</q-td>
                    <q-td key="nmotor" :props="props" @click="verItemContratos(props.row)">{{ props.row.nmotor }}</q-td>
                    <q-td key="montotoralvehiculo" :props="props" @click="verItemContratos(props.row)">{{
                      formatoMonedaMexicana(props.row.montotoralvehiculo)
                    }}</q-td>
                    <q-td key="fechacontrato" :props="props" @click="verItemContratos(props.row)">{{
                      formatearFecha(props.row.fechacontrato) }}</q-td>
                  </q-tr>
                </template>
              </q-table>
            </q-card>
          </q-expansion-item>

          <q-separator />

          <q-expansion-item style="background-color: #5cd3ff" icon="mdi-account-cash" label="Pagos Pendientes"
            header-class="text-accent">
            <q-separator />
            <q-card>
              <q-card-section>
                <div class="row">
                  <div class="col">
                    <div class="text-h6 text-primary">
                      Cuentas Pendientes por Pagar del Cliente
                    </div>
                    <div class="text-subtitle2 text-grey">
                      Podras ver los detalles de pagos pendientes del Cliente
                    </div>
                  </div>
                  <div class="col text-right">
                    <q-btn color="green" style="width: 200px" icon="mdi-table" label="EXPORTAR EXCEL"
                      @click="exportarExcelPagosPendientes()" />
                  </div>
                </div>
              </q-card-section>
              <q-separator />
              <q-table dense class="shadow-0" :data="dataListCuentas" :columns="columnsCuentas" color="primary"
                row-key="_id" :pagination="initialPaginationCuentas">
                <template v-slot:body="props">
                  <q-tr :props="props" class="hover-fila">
                    <q-td key="nombre" :props="props" @click="verItem(props.row)">{{ props.row.nombre }}</q-td>
                    <q-td key="concepto" :props="props" @click="verItem(props.row)">{{ props.row.concepto }}</q-td>
                    <q-td key="monto" :props="props" @click="verItem(props.row)">{{
                      formatoMonedaMexicana(props.row.monto) }}</q-td>
                    <q-td key="tipo" :props="props" @click="verItem(props.row)">{{
                      props.row.tipo ? props.row.tipo.toUpperCase() : ""
                    }}</q-td>
                    <q-td key="fechacreacion" :props="props" @click="verItem(props.row)">{{
                      formatearFecha(props.row.fechacreacion) }}</q-td>
                    <q-td key="fechamaximapago" :props="props" @click="verItem(props.row)">{{
                      formatearFecha(props.row.fechamaximapago) }}</q-td>
                    <q-td key="estado" :props="props">
                      <q-badge v-if="props.row.estado == 'XC'" color="orange" label="Cuenta por Cobrar" />
                      <q-badge v-if="props.row.estado == 'V'" color="purple" label="Pendiente de Validar" />
                      <q-badge v-if="props.row.estado == 'P'" color="green" label="Pagado" />
                    </q-td>
                  </q-tr>
                </template>
              </q-table>

              <div class="row justify-end">
                <q-chip size="md" class="text-right" square color="primary" style="width: 100%" text-color="white">
                  <div class="row full-width">
                    Total a Pagar
                    <q-space />
                    {{ sumaPagosPendientes }}
                  </div>
                </q-chip>
              </div>
            </q-card>
          </q-expansion-item>

          <q-separator />

          <q-expansion-item style="background-color: #8ae0ff" icon="mdi-account-cash" label="Estado de Cuenta"
            header-class="text-accent">
            <q-separator />
            <q-card>
              <q-card-section>
                <div class="row">
                  <div class="col">
                    <div class="text-h6 text-primary">
                      Estado de Cuenta del Cliente
                    </div>
                    <div class="text-subtitle2 text-grey">
                      Podras ver los detalles de pagos vehiculo del Cliente
                    </div>
                  </div>
                  <div class="col text-right">
                    <q-btn color="green" style="width: 200px" icon="mdi-table" label="EXPORTAR EXCEL"
                      @click="exportarExcelEstadoCuenta()" />
                  </div>
                </div>
              </q-card-section>
              <q-separator />
              <q-list v-for="a in listaEstadoCuentas" :key="a._id_vehiculo">
                <q-card-section>
                  <div class="row" v-if="listaEstadoCuentas.length != 0">
                    <div class="col">
                      <div class="text-subtitle2 text-primary">
                        {{ a.vehiculo.toUpperCase() }}
                      </div>
                    </div>
                  </div>
                </q-card-section>
                <q-table v-if="listaEstadoCuentas.length != 0" dense class="shadow-0" :data="a.cuentas"
                  :columns="columnsCuentas" color="primary" row-key="_id" :pagination="initialPaginationCuentas">
                  <template v-slot:body="props">
                    <q-tr :props="props" class="hover-fila">
                      <q-td key="nombre" :props="props" @click="verItem(props.row)">{{ props.row.nombre }}</q-td>
                      <q-td key="concepto" :props="props" @click="verItem(props.row)">{{ props.row.concepto }}</q-td>
                      <q-td key="monto" :props="props" @click="verItem(props.row)">{{
                        formatoMonedaMexicana(props.row.monto) }}</q-td>
                      <q-td key="tipo" :props="props" @click="verItem(props.row)">{{
                        props.row.tipo ? props.row.tipo.toUpperCase() : ""
                      }}</q-td>
                      <q-td key="fechacreacion" :props="props" @click="verItem(props.row)">{{
                        formatearFecha(props.row.fechacreacion) }}</q-td>
                      <q-td key="fechamaximapago" :props="props" @click="verItem(props.row)">{{
                        formatearFecha(props.row.fechamaximapago) }}</q-td>
                      <q-td key="estado" :props="props">
                        <q-badge v-if="props.row.estado == 'XC'" color="orange" label="Cuenta por Cobrar" />
                        <q-badge v-if="props.row.estado == 'V'" color="purple" label="Pendiente de Validar" />
                        <q-badge v-if="props.row.estado == 'P'" color="green" label="Pagado" />
                      </q-td>
                    </q-tr>
                  </template>
                </q-table>
                <div class="row q-col-gutter-sm">
                  <div class="col-4">
                    <q-chip size="md" class="text-right" square color="primary" style="width: 100%" text-color="white">
                      <div class="row full-width">
                        Total Pagado
                        <q-space />
                        {{ getSumaPorEstado(a.cuentas, "P") }}
                      </div>
                    </q-chip>
                  </div>
                  <div class="col-4">
                    <q-chip size="md" class="text-right" square color="primary" style="width: 100%" text-color="white">
                      <div class="row full-width">
                        Total a Pagar
                        <q-space />
                        {{ getSumaPorEstado(a.cuentas, "XC") }}
                      </div>
                    </q-chip>
                  </div>
                  <div class="col-4 q-pr-sm">
                    <q-chip size="md" class="text-right" square color="primary" style="width: 100%" text-color="white">
                      <div class="row full-width">
                        Total por Validar
                        <q-space />
                        {{ getSumaPorEstado(a.cuentas, "V") }}
                      </div>
                    </q-chip>
                  </div>
                </div>
              </q-list>
            </q-card>
          </q-expansion-item>

          <q-separator />

          <q-expansion-item style="background-color: #b8ecff" icon="mdi-file-document"
            label="Facturas Emitidas al Cliente" header-class="text-accent">
            <q-separator />
            <q-card>
              <q-card-section>
                <div class="row">
                  <div class="col">
                    <div class="text-h6 text-primary">Facturas Emitidas</div>
                    <div class="text-subtitle2 text-grey">
                      Podras ver los detalles de los CFDI emitidas al cliente
                    </div>
                  </div>
                  <div class="col text-right">
                    <q-btn color="green" style="width: 200px" icon="mdi-table" label="EXPORTAR EXCEL"
                      @click="exportarExcelComprobantes" />
                  </div>
                </div>
              </q-card-section>
              <q-separator />
              <q-table :data="dataComprobantes" :columns="columnsComprobantes" row-key="_id"
                :pagination="initialPaginationComprobantes" class="shadow-0" dense>
                <template v-slot:body="props">
                  <q-tr :props="props" class="hover-fila">
                    <q-td key="serie" :props="props" @click="VerPdf(props.row)">{{ props.row.serie }}</q-td>
                    <q-td key="folio" :props="props" @click="VerPdf(props.row)">
                      {{ props.row.folio }}
                    </q-td>
                    <q-td key="fecha" :props="props" @click="VerPdf(props.row)">{{ FormatDate(props.row.fecha) }}</q-td>
                    <q-td key="rfc" :props="props" @click="VerPdf(props.row)">{{
                      props.row.rfc
                    }}</q-td>
                    <q-td key="nombre" :props="props" @click="VerPdf(props.row)">{{ props.row.nombre }}</q-td>

                    <q-td key="subTotal" :props="props" @click="VerPdf(props.row)">{{ FormatCurrency(props.row.subTotal)
                    }}</q-td>
                    <q-td key="total" :props="props" @click="VerPdf(props.row)">{{ FormatCurrency(props.row.total)
                    }}</q-td>
                    <q-td key="moneda" :props="props" @click="VerPdf(props.row)">{{ props.row.moneda }}</q-td>

                    <q-td key="formaPago" :props="props" @click="VerPdf(props.row)">{{ props.row.formaPago }}</q-td>
                    <q-td key="metodoPago" :props="props" @click="VerPdf(props.row)">{{ props.row.metodoPago }}</q-td>

                    <q-td key="solicitudCancelacion" :props="props" @click="VerPdf(props.row)">{{
                      props.row.solicitudCancelacion }}</q-td>
                    <q-td key="oc" :props="props" @click="VerPdf(props.row)">{{
                      props.row.oc
                    }}</q-td>
                    <q-td key="folioFiscal" :props="props" @click="VerPdf(props.row)">{{ props.row.folioFiscal }}</q-td>
                  </q-tr>
                </template>
              </q-table>
              <div class="row q-col-gutter-sm">
                <div class="col-6">
                  <q-chip size="md" class="text-right" square color="primary" style="width: 100%" text-color="white">
                    <div class="row full-width">
                      Total Facturado
                      <q-space />
                      {{ getSumaComprobantes }}
                    </div>
                  </q-chip>
                </div>
                <div class="col-6 q-pr-sm">
                  <q-chip size="md" class="text-right" square color="primary" style="width: 100%" text-color="white">
                    <div class="row full-width">
                      SubTotal Facturado
                      <q-space />
                      {{ getSumaComprobantesSubtotal }}
                    </div>
                  </q-chip>
                </div>
              </div>
            </q-card>
          </q-expansion-item>
          <q-separator />

          <q-expansion-item style="background-color: #e6f8ff" icon="mdi-file-document" label="Complementos de Pagos"
            header-class="text-accent">
            <q-separator />
            <q-card>
              <q-card-section>
                <div class="row">
                  <div class="col">
                    <div class="text-h6 text-primary">
                      Complementos de Pago Emitidas
                    </div>
                    <div class="text-subtitle2 text-grey">
                      Podras ver los detalles de los CFDI de Complementos de
                      Pago emitidas al cliente
                    </div>
                  </div>
                  <div class="col text-right">
                    <q-btn color="green" style="width: 200px" icon="mdi-table" label="EXPORTAR EXCEL"
                      @click="exportarExcelComplementos()" />
                  </div>
                </div>
              </q-card-section>
              <q-separator />
              <q-table :data="dataComprobantesComplementos" :columns="columnsComplementos" row-key="rfc"
                :pagination="initialPaginationComplementos" dense>
                <template v-slot:body="props">
                  <q-tr :props="props">
                    <q-td key="serie" :props="props" @click="VerPdfPago(props.row)">{{ props.row.serie }}</q-td>
                    <q-td key="folio" :props="props" @click="VerPdfPago(props.row)">
                      {{ props.row.folio }}
                    </q-td>
                    <q-td key="fecha" :props="props" @click="VerPdfPago(props.row)">{{ FormatDate(props.row.fecha)
                    }}</q-td>
                    <q-td key="rfc" :props="props" @click="VerPdfPago(props.row)">{{ props.row.rfc }}</q-td>
                    <q-td key="nombre" :props="props" @click="VerPdfPago(props.row)">{{ props.row.nombre }}</q-td>

                    <q-td key="subTotal" :props="props" @click="VerPdfPago(props.row)">{{
                      FormatCurrency(props.row.subTotal) }}</q-td>
                    <q-td key="total" :props="props" @click="VerPdfPago(props.row)">{{ FormatCurrency(props.row.total)
                    }}</q-td>
                    <q-td key="moneda" :props="props" @click="VerPdfPago(props.row)">{{ props.row.moneda }}</q-td>
                    <q-td key="solicitudCancelacion" :props="props" @click="VerPdfPago(props.row)">{{
                      props.row.solicitudCancelacion }}</q-td>
                    <q-td key="folioFiscal" :props="props" @click="VerPdfPago(props.row)">{{ props.row.folioFiscal
                    }}</q-td>
                  </q-tr>
                </template>
              </q-table>
            </q-card>
          </q-expansion-item>
          <q-separator />
        </q-list>
      </q-card-section>
    </q-card>
  </q-page>
</template>
<script>
import axios from "axios";
import * as XLSX from "xlsx";
import moment from "moment";
import { QSpinnerClock } from "quasar";
import VisorPdf from "../../PDF/VisorPdf.vue";

export default {
  components: {
    VisorPdf,
  },
  data() {
    return {
      clientes: [],
      clienteSelect: {
        texto: "",
      },
      fechaI: new Date(),
      fechaF: new Date(),

      loading: false,
      listaCarros: [],
      columns: [
        {
          name: "marca",
          label: "Marca",
          field: "marca",
          align: "center",
          sortable: true,
        },
        {
          name: "modelo",
          label: "Modelo",
          field: "modelo",
          align: "center",
          sortable: true,
        },
        {
          name: "version",
          label: "Versión",
          field: "version",
          align: "center",
          sortable: true,
        },
        {
          name: "tipoVehiculo",
          label: "Tipo de Vehiculo",
          field: "tipoVehiculo",
          align: "center",
          sortable: true,
        },
        {
          name: "anio",
          label: "Añor",
          field: "anio",
          align: "center",
          sortable: true,
        },
        {
          name: "color",
          label: "Color",
          field: "color",
          align: "center",
          sortable: true,
        },
        {
          name: "agencia",
          label: "Agencia",
          field: "agencia",
          align: "center",
          sortable: true,
        },
        {
          name: "numeroMotor",
          label: "Núm. Motor",
          field: "numeroMotor",
          align: "center",
          sortable: true,
        },
        {
          name: "numeroSerie",
          label: "Núm. Serie",
          field: "numeroSerie",
          align: "center",
          sortable: true,
        },
        {
          name: "placa",
          label: "Placa",
          field: "placa",
          align: "center",
          sortable: true,
        },
        {
          name: "permiso",
          label: "Num. Permiso",
          field: "permiso",
          align: "center",
          sortable: true,
        },
        {
          name: "estadoPlaca",
          label: "Estado de Placas",
          field: "estadoPlaca",
          align: "center",
          sortable: true,
        },
        {
          name: "fechaadquisicion",
          label: "Fecha de Adquisición",
          field: "fechaadquisicion",
          align: "center",
          sortable: true,
        },
      ],
      initialPagination: {
        sortBy: "nombre",
        descending: false,
        page: 1,
        rowsPerPage: 10,
      },

      dataListContratos: [],
      columnsContratos: [
        {
          name: "nregistro",
          label: "Registro",
          field: "nregistro",
          align: "center",
          sortable: true,
        },
        {
          name: "nombre",
          label: "Cliente",
          field: "nombre",
          align: "center",
          sortable: true,
        },
        {
          name: "plazos",
          label: "Plazos",
          field: "plazos",
          align: "center",
          sortable: true,
        },
        {
          name: "vehiculo",
          label: "Vehiculo",
          field: "vehiculo",
          align: "center",
          sortable: true,
        },
        {
          name: "nserie",
          label: "N. Serie",
          field: "nserie",
          align: "center",
          sortable: true,
        },
        {
          name: "nmotor",
          label: "N. Motor",
          field: "nmotor",
          align: "center",
          sortable: true,
        },
        {
          name: "montotoralvehiculo",
          label: "Monto Total del Vehiculo",
          field: "fechamaximapago",
          align: "center",
          sortable: true,
        },
        {
          name: "fechacontrato",
          label: "Fecha de contrato",
          field: "fechacontrato",
          align: "center",
          sortable: true,
        },
      ],
      initialPaginationContratos: {
        sortBy: "nombre",
        descending: false,
        page: 1,
        rowsPerPage: 10,
      },

      dataListCuentas: [],
      columnsCuentas: [
        {
          name: "nombre",
          label: "Cliente",
          field: "nombre",
          align: "center",
          sortable: true,
        },
        {
          name: "concepto",
          label: "Concepto",
          field: "concepto",
          align: "center",
          sortable: true,
        },
        {
          name: "monto",
          label: "Monto",
          field: "monto",
          align: "right",
          sortable: true,
        },
        {
          name: "tipo",
          label: "Tipo",
          field: "tipo",
          align: "center",
          sortable: true,
        },
        {
          name: "fechacreacion",
          label: "Fecha",
          field: "fechacreacion",
          align: "center",
          sortable: true,
        },
        {
          name: "fechamaximapago",
          label: "Fecha Maxima De Pago",
          field: "fechamaximapago",
          align: "center",
          sortable: true,
        },
        {
          name: "estado",
          label: "Estatus",
          field: "estado",
          align: "center",
          sortable: true,
        },
      ],
      initialPaginationCuentas: {
        sortBy: "nombre",
        descending: false,
        page: 1,
        rowsPerPage: 10,
      },

      listaEstadoCuentas: [],
      dataComprobantesComplementos: [],
      columnsComplementos: [
        {
          name: "serie",
          align: "left",
          label: "Serie",
          field: "serie",
          sortable: true,
        },
        {
          name: "folio",
          align: "left",
          label: "Folio",
          field: "folio",
          sortable: true,
        },
        {
          name: "fecha",
          align: "left",
          label: "Fecha",
          field: "fecha",
          sortable: true,
        },
        {
          name: "rfc",
          align: "left",
          label: "RFC",
          field: "rfc",
          sortable: true,
        },
        {
          name: "nombre",
          align: "left",
          label: "Nombre",
          field: "nombre",
          sortable: true,
        },
        {
          name: "subTotal",
          align: "right",
          label: "SubTotal",
          field: "subTotal",
          sortable: true,
        },
        {
          name: "total",
          align: "right",
          label: "Total",
          field: "total",
          sortable: true,
        },
        {
          name: "moneda",
          align: "left",
          label: "Moneda",
          field: "moneda",
          sortable: true,
        },
        {
          name: "solicitudCancelacion",
          align: "left",
          label: "Solicitud de Cancelación",
          field: "solicitudCancelacion",
          sortable: true,
        },
        {
          name: "folioFiscal",
          align: "left",
          label: "Folio Fiscal",
          field: "folioFiscal",
          sortable: true,
        },
      ],
      initialPaginationComplementos: {
        sortBy: "nombre",
        descending: false,
        page: 1,
        rowsPerPage: 10,
      },

      dataComprobantes: [],
      columnsComprobantes: [
        {
          name: "serie",
          align: "left",
          label: "Serie",
          field: "serie",
          sortable: true,
        },
        {
          name: "folio",
          align: "left",
          label: "Folio",
          field: "folio",
          sortable: true,
        },
        {
          name: "fecha",
          align: "left",
          label: "Fecha",
          field: "fecha",
          sortable: true,
        },
        {
          name: "rfc",
          align: "left",
          label: "RFC",
          field: "rfc",
          sortable: true,
        },
        {
          name: "nombre",
          align: "left",
          label: "Nombre",
          field: "nombre",
          sortable: true,
        },
        {
          name: "subTotal",
          align: "right",
          label: "SubTotal",
          field: "subTotal",
          sortable: true,
        },
        {
          name: "total",
          align: "right",
          label: "Total",
          field: "total",
          sortable: true,
        },
        {
          name: "moneda",
          align: "left",
          label: "Moneda",
          field: "moneda",
          sortable: true,
        },
        {
          name: "formaPago",
          align: "left",
          label: "Forma de Pago",
          field: "formaPago",
          sortable: true,
        },
        {
          name: "metodoPago",
          align: "left",
          label: "Método de Pago",
          field: "metodoPago",
          sortable: true,
        },
        {
          name: "solicitudCancelacion",
          align: "left",
          label: "Solicitud de Cancelación",
          field: "solicitudCancelacion",
          sortable: true,
        },
        { name: "oc", align: "left", label: "OC", field: "oc", sortable: true },
        {
          name: "folioFiscal",
          align: "left",
          label: "Folio Fiscal",
          field: "folioFiscal",
          sortable: true,
        },
      ],
      initialPaginationComprobantes: {
        sortBy: "nombre",
        descending: false,
        page: 1,
        rowsPerPage: 10,
      },
      dialogPdf: false,

      sumaPagosPendientes: "",

      itemsAños: [
        "2026",
        "2025",
        "2024",
        "2023",
        "2022",
        "2021",
        "2020",
        "2019",
        "2018",
      ],
      itemsMeses: [
        { mes: "ENERO", valor: 1 },
        { mes: "FEBRERO", valor: 2 },
        { mes: "MARZO", valor: 3 },
        { mes: "ABRIL", valor: 4 },
        { mes: "MAYO", valor: 5 },
        { mes: "JUNIO", valor: 6 },
        { mes: "JULIO", valor: 7 },
        { mes: "AGOSTO", valor: 8 },
        { mes: "SEPTIEMBRE", valor: 9 },
        { mes: "OCTUBRE", valor: 10 },
        { mes: "NOVIEMBRE", valor: 11 },
        { mes: "DICIEMBRE", valor: 12 },
      ],
      selectedAño: null,
      selectedMesInicial: null,
      selectedMesFinal: null,

      columnsIE: [
        {
          name: "año",
          align: "center",
          label: "Año",
          field: "año",
          sortable: true,
        },
        {
          name: "mes",
          align: "center",
          label: "Mes",
          field: "mes",
          sortable: true,
        },
        {
          name: "ingresos",
          align: "center",
          label: "No. Cuentas Cobradas",
          field: "ingresos",
          sortable: true,
        },
        {
          name: "totalI",
          align: "right",
          label: "Importe Cobrado",
          field: "totalI",
          sortable: true,
        },
        {
          name: "egresos",
          align: "center",
          label: "No. Cuentas Pagadas",
          field: "egresos",
          sortable: true,
        },
        {
          name: "totalE",
          align: "right",
          label: "Importe Pagado",
          field: "totalE",
          sortable: true,
        },
        {
          name: "total",
          align: "right",
          label: "Importe Total",
          field: "total",
          sortable: true,
        },
      ],
      loadingIE: false,
      listaIE: [],
      dialogDetalleGastos: false,
      dialogDetalleIngresos: false,

      dataListIngresos: [],
      loadingIngresos: false,
      columnsIngresos: [
        {
          name: "nombre",
          label: "Cliente",
          field: "nombre",
          align: "center",
          sortable: true,
        },
        {
          name: "concepto",
          label: "Concepto",
          field: "concepto",
          align: "center",
          sortable: true,
        },
        {
          name: "monto",
          label: "Monto",
          field: "monto",
          align: "right",
          sortable: true,
        },
        {
          name: "tipo",
          label: "Tipo",
          field: "tipo",
          align: "center",
          sortable: true,
        },
        {
          name: "fechacreacion",
          label: "Fecha",
          field: "fechacreacion",
          align: "center",
          sortable: true,
        },
        {
          name: "fechamaximapago",
          label: "Fecha Maxima De Pago",
          field: "fechamaximapago",
          align: "center",
          sortable: true,
        },
        {
          name: "estado",
          label: "Estatus",
          field: "estado",
          align: "center",
          sortable: true,
        },
      ],
      dataListGastos: [],
      loadingGastos: false,
      columnsGastos: [
        {
          name: "nombre",
          label: "Proveedor",
          field: "nombre",
          align: "center",
          sortable: true,
        },
        {
          name: "concepto",
          label: "Concepto",
          field: "concepto",
          align: "center",
          sortable: true,
        },
        {
          name: "monto",
          label: "Monto",
          field: "monto",
          align: "right",
          sortable: true,
        },
        {
          name: "tipo",
          label: "Tipo",
          field: "tipo",
          align: "center",
          sortable: true,
        },
        {
          name: "fechacreacion",
          label: "Fecha",
          field: "fechacreacion",
          align: "center",
          sortable: true,
        },
        {
          name: "fechamaximapago",
          label: "Fecha Maxima De Pago",
          field: "fechamaximapago",
          align: "center",
          sortable: true,
        },
        {
          name: "estado",
          label: "Estatus",
          field: "estado",
          align: "center",
          sortable: true,
        },
      ],
    };
  },
  mounted() { },
  computed: {
    adminStore() {
      return this.$store.state.auth.usuario;
    },

    getSumaPorEstado() {
      return (lista, estado) => {
        return this.formatoMonedaMexicana(
          lista
            .filter((pago) => pago.estado === estado)
            .reduce((total, pago) => total + pago.monto, 0)
        );
      };
    },
    getSumaComprobantesSubtotal() {
      return this.formatoMonedaMexicana(
        this.dataComprobantes.reduce((total, pago) => total + pago.total, 0)
      );
    },
    getSumaComprobantes() {
      return this.formatoMonedaMexicana(
        this.dataComprobantes.reduce((total, pago) => total + pago.subTotal, 0)
      );
    },
    getSumaTotalIngresos() {
      return this.formatoMonedaMexicana(
        this.listaIE.reduce((total, pago) => total + pago.totalI, 0)
      );
    },
    getSumaTotalEgresos() {
      return this.formatoMonedaMexicana(
        this.listaIE.reduce((total, pago) => total + pago.totalE, 0)
      );
    },
  },
  created() {
    this.GetClientes();
  },
  methods: {
    verItemAuto(item) {
      console.log(item);
    },
    verItemContratos(item) {
      console.log(item);
    },
    async GetClientes() {
      try {
        let respuesa = await axios.get(
          "Configuracion/GetUsuariosDatosFiscales/"
        );
        this.clientes = respuesa.data.map((cliente) => ({
          ...cliente,
          texto: `${cliente.rfc} -  ${cliente.razon_social}`,
        }));
      } catch (error) {
        console.log(error);
      }
    },

    async GetReporteGeneral() {
      this.$q.loading.show({
        spinner: QSpinnerClock,
        spinnerColor: "white",
        spinnerSize: 90,
        message: "Generando reporte. Espere...",
        messageColor: "white",
      });

      await this.GetReporteIE();
      this.$q.loading.hide();
    },

    async GetReporteIE() {
      let fecha1 =
        this.selectedAño + "-" + this.selectedMesInicial.valor + "-01";
      let fecha2 = this.selectedAño + "-" + this.selectedMesFinal.valor + "-01";
      try {
        let respuesta = await axios.get(
          "Reportes/GetReporteIEAsync/" + fecha1 + "/" + fecha2
        );
        console.log(respuesta);
        this.listaIE = respuesta.data;
      } catch (error) {
        console.log(error);
      }
    },

    async GetReporte() {
      this.$q.loading.show({
        spinner: QSpinnerClock,
        spinnerColor: "white",
        spinnerSize: 90,
        message: "Generando reporte. Espere...",
        messageColor: "white",
      });

      await this.GetReporteCarros();
      await this.GetComprobantes();
      await this.GetComprobantesComplementosPago();
      this.$q.loading.hide();
    },

    async GetReporteCarros() {
      try {
        let respuesta = await axios.get(
          "Reportes/GetReportePorClienteAsync/" + this.clienteSelect._id_cliente
        );
        console.log(respuesta);

        this.listaCarros = respuesta.data.autos;
        this.dataListContratos = respuesta.data.contratos;
        this.dataListCuentas = respuesta.data.pagosPendientes;
        this.listaEstadoCuentas = respuesta.data.estadoCuenta;

        this.sumaPagosPendientes = this.sum(this.dataListCuentas, "monto");
      } catch (error) {
        console.log(error);
      }
    },

    async GetComprobantesComplementosPago() {
      try {
        let response = await axios.get(
          "https://api-beta-erp.contago.com.mx/api/Comprobantes/GetComprobanteRFCAsync/erp_IIA040805DZ4/comprobantes_pagos/PAGO/" +
          this.clienteSelect.rfc
        );
        const x = response.data;
        console.log(x);
        this.dataComprobantesComplementos = x;
      } catch (error) {
        console.log(error);
        this.$q.loading.hide();
      }
    },

    async GetComprobantes() {
      console.log(this.clienteSelect.rfc);
      try {
        let response = await axios.get(
          "https://api-beta-erp.contago.com.mx/api/Comprobantes/GetComprobanteRFCAsync/erp_IIA040805DZ4/comprobantes_emitidos/FACTURA/" +
          this.clienteSelect.rfc
        );
        const x = response.data;
        this.dataComprobantes = x;
      } catch (error) {
        console.log(error);
        this.$q.loading.hide();
      }
    },

    formatoMonedaMexicana(valor) {
      return valor.toLocaleString("es-MX", {
        style: "currency",
        currency: "MXN",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },

    formatearFecha(isoString) {
      const fecha = new Date(isoString);

      const dia = String(fecha.getUTCDate()).padStart(2, "0");
      const mes = String(fecha.getUTCMonth() + 1).padStart(2, "0");
      const anio = fecha.getUTCFullYear();

      const hora = String(fecha.getUTCHours()).padStart(2, "0");
      const minutos = String(fecha.getUTCMinutes()).padStart(2, "0");
      const segundos = String(fecha.getUTCSeconds()).padStart(2, "0");

      return `${dia}/${mes}/${anio}`;
    },

    FormatCurrency(value) {
      return value.toLocaleString("en-US", {
        style: "currency",
        currency: "USD",
      });
    },

    FormatDate(value) {
      let fecha = new Date(value);
      let dia = fecha.getDate();
      let mes = fecha.toLocaleString("es-ES", { month: "long" }); // Obtener el mes en formato de letra
      let anio = fecha.getFullYear();
      let formatoDeseado = `${dia}-${mes}-${anio}`;
      return formatoDeseado;
    },

    exportarExcelAutos() {
      try {
        const headers = this.columns.map((col) => col.label);
        const datos = this.listaCarros.map((item) => {
          const fila = {};
          this.columns.forEach((col) => {
            if (col.field === "fechaadquisicion") {
              fila[col.label] = this.formatearFecha(item[col.field]);
            } else {
              fila[col.label] = item[col.field];
            }
          });
          return fila;
        });

        const ws = XLSX.utils.json_to_sheet(datos, { header: headers });
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Autos del Cliente");

        XLSX.writeFile(
          wb,
          "AutosCliente_" + this.clienteSelect.texto + ".xlsx"
        );
      } catch (error) {
        console.error("Error al exportar:", error);
        this.$q.notify({
          type: "negative",
          message: "Error al exportar a Excel",
        });
      }
    },

    exportarExcelContratos() {
      try {
        // Genera los encabezados desde tus columns
        const headers = this.columnsContratos.map((col) => col.label);

        // Ordena y transforma la data según las columnas definidas
        const datos = this.dataListContratos.map((item) => {
          const fila = {};
          this.columnsContratos.forEach((col) => {
            console.log(col);
            if (col.field === "fechacontrato") {
              fila[col.label] = this.formatearFecha(item[col.field]);
            } else if (col.field === "vehiculo") {
              fila[col.label] =
                item["marca"] + " " + item["modelo"] + " " + item["color"];
            } else {
              fila[col.label] = item[col.field];
            }
          });
          return fila;
        });

        // Crea la hoja y el libro
        const ws = XLSX.utils.json_to_sheet(datos, { header: headers });
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Contratos del Cliente");

        // Exporta el archivo Excel
        XLSX.writeFile(
          wb,
          "ContratosCliente_" + this.clienteSelect.texto + ".xlsx"
        );
      } catch (error) {
        console.error("Error al exportar:", error);
        this.$q.notify({
          type: "negative",
          message: "Error al exportar a Excel",
        });
      }
    },

    exportarExcelPagosPendientes() {
      try {
        // Genera los encabezados desde tus columns
        const headers = this.columnsCuentas.map((col) => col.label);

        // Ordena y transforma la data según las columnas definidas
        const datos = this.dataListCuentas.map((item) => {
          const fila = {};
          this.columnsCuentas.forEach((col) => {
            if (col.field === "fechacreacion") {
              fila[col.label] = this.formatearFecha(item[col.field]);
            } else if (col.field === "fechamaximapago") {
              fila[col.label] = this.formatearFecha(item[col.field]);
            } else {
              fila[col.label] = item[col.field];
            }

            if (col.field === "estado") {
              fila[col.label] = this.formatearEstado(item[col.field]);
            }
          });
          return fila;
        });

        // Crea la hoja y el libro
        const ws = XLSX.utils.json_to_sheet(datos, { header: headers });
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Pagos Pendientes del Cliente");

        // Exporta el archivo Excel
        XLSX.writeFile(
          wb,
          "PagosPendientesCliente_" + this.clienteSelect.texto + ".xlsx"
        );
      } catch (error) {
        console.error("Error al exportar:", error);
        this.$q.notify({
          type: "negative",
          message: "Error al exportar a Excel",
        });
      }
    },

    exportarExcelEstadoCuenta() {
      try {
        // Crea un nuevo libro de Excel
        const wb = XLSX.utils.book_new();

        // Recorre cada vehículo
        this.listaEstadoCuentas.forEach((vehiculoObj, index) => {
          // Mapeamos las cuentas a formato tabular
          const cuentasData = vehiculoObj.cuentas.map((c) => ({
            Cliente: c.cliente,
            Procedencia: c.procedencia,
            Concepto: c.concepto,
            Monto: c.monto,
            Tipo: c.tipo,
            "Fecha Máx. Pago": this.formatearFecha(c.fechamaximapago),
            "Fecha Creación": this.formatearFecha(c.fechacreacion),
            Estado: this.formatearEstado(c.estado),
          }));

          // Creamos la hoja con los datos de cuentas
          const ws = XLSX.utils.json_to_sheet(cuentasData);

          // Nombramos la hoja (limitado a 31 caracteres por Excel)
          let nombreHoja = vehiculoObj.vehiculo.substring(0, 31);
          if (!nombreHoja) nombreHoja = `Vehículo ${index + 1}`;

          XLSX.utils.book_append_sheet(wb, ws, nombreHoja);
        });

        // Exportamos el libro
        XLSX.writeFile(
          wb,
          "EstadoCuentaCliente_" + this.clienteSelect.texto + ".xlsx"
        );
      } catch (error) {
        console.error("Error al exportar:", error);
        this.$q.notify({
          type: "negative",
          message: "Error al exportar a Excel",
        });
      }
    },
    formatearEstado(item) {
      let estado = "";
      if (item == "XC") {
        estado = "POR COBRAR";
      }
      if (item == "P") {
        estado = "PAGADO";
      }
      if (item == "V") {
        estado = "POR VALIDAR";
      }
      return estado;
    },
    exportarExcelComprobantes() {
      try {
        const headers = this.columnsComprobantes.map((col) => col.label);
        const datos = this.dataComprobantes.map((item) => {
          const fila = {};
          this.columnsComprobantes.forEach((col) => {
            if (col.field === "fecha") {
              fila[col.label] = this.FormatDate(item[col.field]);
            } else {
              fila[col.label] = item[col.field];
            }
          });
          return fila;
        });
        const ws = XLSX.utils.json_to_sheet(datos, { header: headers });
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Comprobantes Emitidos");

        XLSX.writeFile(
          wb,
          "ComprobantesEmitidosCliente_" + this.clienteSelect.texto + ".xlsx"
        );
      } catch (error) {
        console.error("Error al exportar:", error);
        this.$q.notify({
          type: "negative",
          message: "Error al exportar a Excel",
        });
      }
    },

    exportarExcelComplementos() {
      try {
        const headers = this.columnsComplementos.map((col) => col.label);
        const datos = this.dataComprobantesComplementos.map((item) => {
          const fila = {};
          this.columnsComplementos.forEach((col) => {
            if (col.field === "fecha") {
              fila[col.label] = this.FormatDate(item[col.field]);
            } else {
              fila[col.label] = item[col.field];
            }
          });
          return fila;
        });
        const ws = XLSX.utils.json_to_sheet(datos, { header: headers });
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "ComplementosPago");

        XLSX.writeFile(
          wb,
          "ComplementosPagoEmitidosCliente_" +
          this.clienteSelect.texto +
          ".xlsx"
        );
      } catch (error) {
        console.error("Error al exportar:", error);
        this.$q.notify({
          type: "negative",
          message: "Error al exportar a Excel",
        });
      }
    },

    exportarExcelIngresosGastos() {
      try {
        const headers = this.columnsIE.map((col) => col.label);
        const datos = this.listaIE.map((item) => {
          const fila = {};
          this.columnsIE.forEach((col) => {
            fila[col.label] = item[col.field];
          });
          return fila;
        });
        const ws = XLSX.utils.json_to_sheet(datos, { header: headers });
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Ingresos vs Gastos");

        XLSX.writeFile(
          wb,
          "Ingresos_Gastos_del_" +
          this.selectedAño +
          "_de_" +
          this.selectedMesInicial.mes +
          "_a_" +
          this.selectedMesFinal.mes +
          ".xlsx"
        );
      } catch (error) {
        console.error("Error al exportar:", error);
        this.$q.notify({
          type: "negative",
          message: "Error al exportar a Excel",
        });
      }
    },

    CierraDialogPdf() {
      this.dialogPdf = false;
    },

    CierraDialogPdfTimbrado() {
      this.dialogPdf = false;
    },

    async VerPdf(item) {
      let empresa = { ...this.$store.state.auth.empresaStore };
      let color = empresa.color;
      try {
        this.$store.state.auth.vistaPreviaStore = {
          comprobante: null,
          color: color,
          logo: "",
          rfc: "SCA900316JP0",
          folioFiscal: item.folioFiscal,
          tipoComprobanteInterno: "FACTURA",
        };
        this.dialogPdf = true;
      } catch (error) {
        console.log(error);
      }
    },

    async VerPdfPago(item) {
      try {
        this.$store.state.auth.vistaPreviaStore = {
          folioFiscal: item.folioFiscal,
          tipoComprobanteInterno: "PAGO",
        };
        this.dialogPdf = true;
      } catch (error) {
        console.log(error);
      }
    },

    sum(array, key) {
      return this.formatoMonedaMexicana(
        array.reduce((a, b) => a + (b[key] || 0), 0)
      );
    },

    async verDetallesIngresos(item) {
      this.loadingIngresos = true;
      const meses = [
        "ENERO",
        "FEBRERO",
        "MARZO",
        "ABRIL",
        "MAYO",
        "JUNIO",
        "JULIO",
        "AGOSTO",
        "SEPTIEMBRE",
        "OCTUBRE",
        "NOVIEMBRE",
        "DICIEMBRE",
      ];

      const numeroMes = meses.indexOf(item.mes.toUpperCase()) + 1;

      let fecha1 = item.año + "-" + numeroMes + "-01";
      let fecha2 = item.año + "-" + numeroMes + "-01";
      try {
        let respuesa = await axios.get(
          "CXC/GetListaCxcPagados/" + fecha1 + "/" + fecha2
        );
        console.log(respuesa);
        this.dataListIngresos = respuesa.data;
        this.dialogDetalleIngresos = true;

        this.loadingIngresos = false;
      } catch (error) {
        this.loadingIngresos = false;
        console.log(error);
      }
    },
    async verDetallesGastos(item) {
      this.loadingGastos = true;
      const meses = [
        "ENERO",
        "FEBRERO",
        "MARZO",
        "ABRIL",
        "MAYO",
        "JUNIO",
        "JULIO",
        "AGOSTO",
        "SEPTIEMBRE",
        "OCTUBRE",
        "NOVIEMBRE",
        "DICIEMBRE",
      ];

      const numeroMes = meses.indexOf(item.mes.toUpperCase()) + 1;

      let fecha1 = item.año + "-" + numeroMes + "-01";
      let fecha2 = item.año + "-" + numeroMes + "-01";
      try {
        let respuesa = await axios.get(
          "CXC/GetListaCxPPagados/" + fecha1 + "/" + fecha2
        );
        console.log(respuesa);
        this.dataListGastos = respuesa.data;
        this.dialogDetalleGastos = true;

        this.loadingGastos = false;
      } catch (error) {
        this.loadingGastos = false;
        console.log(error);
      }
    },
  },
};
</script>
<style>
.hover-fila:hover td {
  cursor: pointer;
  background: #dcf6ff;
}

.hover-fila-row:hover {
  cursor: pointer;
  background: #dcf6ff;
}
</style>